class CustomerDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.overlay = this.querySelector('#CustomerDrawer-Overlay');
    if (this.overlay) this.overlay.addEventListener('click', this.close.bind(this));

    this.setTriggerAccessibility();
  }

  setTriggerAccessibility() {
    const trigger = document.querySelector('[data-customer-drawer-open]');
    if (!trigger) return;

    trigger.setAttribute('role', 'button');
    trigger.setAttribute('aria-haspopup', 'dialog');

    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(trigger);
    });

    trigger.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(trigger);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = document.getElementById('CustomerDrawer');
        const focusElement =
          this.querySelector('.drawer__inner') || this.querySelector('.drawer__close') || this.querySelector('a, button');

        if (containerToTrapFocusOn && focusElement) {
          trapFocus(containerToTrapFocusOn, focusElement);
        }
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('customer-drawer', CustomerDrawer);
